// extracted by mini-css-extract-plugin
export default {"zoomModal":"m3-z","image":"n3-z","button":"o3-z","isOverlayShown":"p3-z"};